import { GovernanceIssuesContent } from '../Issues/Issues';
import { GovernanceAccessBoundary } from '../GovernanceAccessBoundary';
import { CustomPolicyHeader } from './CustomPolicyHeader';
import { CustomPolicyTabs } from './CustomPolicyTabs';

function CustomPolicyIssuesContent() {
  return (
    <div className='eye:flex eye:flex-col eye:gap-m'>
      <div className='eye:flex eye:flex-col eye:gap-s'>
        <CustomPolicyHeader />
        <CustomPolicyTabs active='issues' />
      </div>
      <GovernanceIssuesContent showTitle={false} />
    </div>
  );
}

function CustomPolicyIssues() {
  return (
    <GovernanceAccessBoundary area='issues'>
      <CustomPolicyIssuesContent />
    </GovernanceAccessBoundary>
  );
}

export default CustomPolicyIssues;
